import dayjs from 'dayjs';
import { ISensor } from 'app/shared/model/sensor.model';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';

export interface ISensorDataDaily {
  id?: number;
  value?: number | null;
  created?: string | null;
  sensor?: ISensor | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<ISensorDataDaily> = {};
